export enum EScheduleEntity {
  STORE = 'STORE',
  AD_SENSE_AD = 'AD_SENSE_AD',
}
